import { Data } from './data';
import { Permission } from './permission';
import { Token } from './token';

export class User extends Data {

    username: string;
    name: string;
    // roles: string[];
    permissions: Permission[];
    role: string;
    email: string;
    password: string;
    is_active: boolean;
    recent_token: Token;
    solde_transaction: number;

    constructor() {
        super(); // on appelle le constructeur du parent;
        this.is_active = false;
    }

    get etat(): string{
        if (this.is_active === true)
        return 'Activé';
        else
        return 'Désactivé';
    }

    get recentConnexion(): String {
        if (this.recent_token !== null && this.recent_token !== undefined)
        return this.formatDate(this.recent_token.created_at);
        else
        return null;
    }



}
